import { testIsFunction, testIsNumber } from '../../lib/test-and-assert/test-base';
import { ScriptLoadingHelper } from '../../qaamgo/modules/sat/helper/promise-script-loader';
import { satGlobals } from '../../qaamgo/sat/helper/sat-globals';
import { assertIsTrue } from '../../lib/test-and-assert/assert-base';

function loadStripeApi() {
    // stripe api is already loaded, no need to try loading it again
    if (isStripeApiLoaded()) {
        return Promise.resolve();
    }

    const stripeApiUrl = 'https://js.stripe.com/v3/';

    // start loading stripe api
    const stripeApiLoader = new ScriptLoadingHelper(stripeApiUrl, isStripeApiLoaded);
    return stripeApiLoader.loadScript();
}

function isStripeApiLoaded() {
    return testIsFunction(window.Stripe) && testIsNumber(window?.Stripe.version);
}

export { isStripeApiLoaded };

class StripeHelper {
    constructor() {
        this.stripe = {};
        this.initialized = false;

        this.cardNumber = null;
        this.cardExpiry = null;
        this.cardCvc = null;
    }

    isInitialized() {
        return this.initialized;
    }

    // TODO add typing for stripe?
    getStripe() {
        assertIsTrue(this.initialized);

        return this.stripe;
    }

    getCardNumber() {
        return this.cardNumber;
    }

    setCardNumber(cardNumber) {
        this.cardNumber = cardNumber;

        return this;
    }

    getCardExpiry() {
        return this.cardExpiry;
    }

    setCardExpiry(cardExpiry) {
        this.cardExpiry = cardExpiry;

        return this;
    }

    getCardCvc() {
        return this.cardCvc;
    }

    setCardCvc(cardCvc) {
        this.cardCvc = cardCvc;

        return this;
    }

    initializeStripe() {
        if (this.isInitialized()) {
            return Promise.resolve();
        }

        return loadStripeApi().then(() => {
            this.stripe = window.Stripe(satGlobals.getStripePk(), {
                locale: satGlobals.getLocale(),
            });

            this.initialized = true;

            return Promise.resolve();
        });
    }
}

if (!global.gStripeHelper) {
    global.gStripeHelper = new StripeHelper();
}

const stripeHelper = global.gStripeHelper;

export { stripeHelper };
